import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import "./dashboardheader.css";
import { enablePushNotifications, getPushStatus, disablePushNotifications } from "../../util/push_client_util";

const DashboardHeader = (props) => {
  const {
    headerTagline,
    fullName,
    messagesPath,
    hasUnreadMessages,
    avatarUrl,
    onOpenProfile,
    fileInputRef,
    onAvatarChange,
    certificationEarned,
  } = props;

  const [pushStatus, setPushStatus] = useState({ supported: true, permission: "default", subscribed: false });
  const [pushBusy, setPushBusy] = useState(false);

  useEffect(() => {
    (async () => {
      try {
        const status = await getPushStatus();
        setPushStatus(status);
      } catch (e) {
        setPushStatus({ supported: false, permission: "unsupported", subscribed: false });
      }
    })();
  }, []);

  const onAllowNotifications = async () => {
    try {
      setPushBusy(true);
      await enablePushNotifications();
      const status = await getPushStatus();
      setPushStatus(status);
      alert("Notifications enabled ✅");
    } catch (e) {
      console.error(e);
      alert(e?.message || "Could not enable notifications.");
    } finally {
      setPushBusy(false);
    }
  };

  const onDisableNotifications = async () => {
    try {
      setPushBusy(true);
      await disablePushNotifications();
      const status = await getPushStatus();
      setPushStatus(status);
      alert("Notifications disabled.");
    } catch (e) {
      console.error(e);
      alert(e?.message || "Could not disable notifications.");
    } finally {
      setPushBusy(false);
    }
  };

  const showAllow =
    pushStatus.supported &&
    (pushStatus.permission !== "granted" || !pushStatus.subscribed);

  const allowLabel =
    pushBusy ? "Working…" :
    pushStatus.permission === "denied" ? "Notifications blocked" :
    "Allow notifications";

  return (
    <header className="dash-header">
      <div className="dash-header-inner dash-container">
        <div className="dash-header-left">
          <div className="dash-logo-text">
            <div className="dash-role-label">{headerTagline}</div>
            <h1 className="dash-title">COSMETINK ACADEMY</h1>
          </div>
          <p className="dash-subtitle">
            Welcome back, <span className="dash-highlight">{fullName}.</span> Your next level starts now.
          </p>
          {pushStatus.supported ? (
  <button
    type="button"
    className={`dash-notify-pill ${showAllow ? "is-off" : "is-on"} ${pushBusy ? "is-busy" : ""}`}
    onClick={showAllow ? onAllowNotifications : onDisableNotifications}
    disabled={pushBusy || (showAllow && pushStatus.permission === "denied")}
    title={showAllow ? "Enable notifications" : "Disable notifications"}
    aria-label={showAllow ? "Enable notifications" : "Disable notifications"}
  >
    {pushBusy
      ? "Working…"
      : showAllow
      ? (pushStatus.permission === "denied" ? "Notifications blocked" : <><i className="fa-regular fa-bell"></i>
&nbsp;Notifications off</>)
      : <><i className="fa-solid fa-bell"></i> &nbsp;Notifications on</>}
  </button>
) : null}

        </div>

        <div className="dash-header-right">
          <div className="dash-header-icon-actions">

            <Link to={messagesPath} className="dash-icon-btn" aria-label="Messages" title="Messages">
              <i className="fa-solid fa-paper-plane" />
              {hasUnreadMessages && <span className="dash-unread-dot" />}
            </Link>




            <div className="dash-user-orb-wrap">
  <button type="button" className="dash-user-orb-btn" onClick={onOpenProfile}>
  <div className="dash-avatar-orb dash-avatar-orb-header">
    <div className="dash-avatar-face">
      {avatarUrl ? (
        <img src={avatarUrl} alt={fullName} />
      ) : (
        <span className="dash-avatar-initials">
          {String(fullName || "A").charAt(0).toUpperCase()}
        </span>
      )}
    </div>

    <div className="dash-avatar-ring" />

    {certificationEarned && (
      <span className="dash-avatar-medal-platinum" title="100-hr Certification Earned">
        🏅
      </span>
    )}
  </div>
</button>

            </div>

            <input
              type="file"
              accept="image/*"
              ref={fileInputRef}
              style={{ display: "none" }}
              onChange={onAvatarChange}
            />
          </div>
        </div>
      </div>
    </header>
  );
};

export default DashboardHeader;
